<template>
  <v-autocomplete v-model="form.groups"
                  v-if="form.userPresentation === 0"
                  label="Which groups?"
                  placeholder="Select group(s)"
                  prepend-icon="fal fa-users"
                  :items="filteredGroups"
                  chips
                  deletable-chips
                  multiple
                  clearable
                  item-value="id"
                  item-text="name">
  </v-autocomplete>
</template>
<script>
import {mapGetters} from 'vuex';
import clone from 'lodash/clone';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'groups',
      'team',
      'user',
    ]),
    filteredGroups() {
      return this.groups;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {

    fetchData() {
      this.$store.dispatch('fetchGroups');
    },
  }
}
</script>
